<template>
  <v-data-table
    disable-pagination
    :hide-default-footer="true"
    :must-sort="true"
    :no-data-text="'You have no rejected invoices'"
    :headers="headers"
    :items="documents"
    :loading="loading"
    class="elevation-1"
    @click:row="(event, { item }) => selectDocument(item.id)"
  >
    <template v-slot:item.icon="{}">
      <v-icon color="error">mdi-alert-circle-outline</v-icon>
    </template>
  </v-data-table>
</template>

<script>
import Auth0Mixin from "@/views/Auth0Mixin";
import documentStatusService from "@/services/documentStatusService";
import dataTableService from "@/services/dataTableService";

export default {
  mixins: [Auth0Mixin],

  data() {
    return {
      headers: [
        { title: "", key: "icon" },
        { title: "Invoice #", key: "docInvoiceNumber" },
        { title: "Purchaser", key: "docARPurchaserName" },
      ],
      documents: [],
      loading: true,
    };
  },

  methods: {
    selectDocument(id) {
      this.$router.push({ name: "Document", params: { id } });
    },

    async init() {
      let rejectedInvoices = await documentStatusService.getRejectedInvoices();
      let translated = dataTableService.translateResultSet(rejectedInvoices, "");
      this.documents = translated.rows;
      this.loading = false;
    },
  },
};
</script>
